<template>
    <div>
        <v-switch
            v-for="option in options"
            :key="option.name"
            :label="option.name"
            :input-value="true"
            v-model="option.enabled"
            @change="$emit('reportOptionUpdated', {payload: option})"></v-switch>
        <v-btn
            style="padding-left: 10px; padding-right: 10px; margin-bottom: 10px"
            color="primary"
            @click="$emit('newReport')">Update Report</v-btn>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            default: () => []
        }
    }
}
</script>
